import React from "react";
import { FaMapMarkedAlt, FaChartLine, FaTools, FaSignOutAlt, FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Drawer.css";

const Drawer = ({ isOpen, toggleDrawer }) => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    toggleDrawer();
    navigate(path);
  };

  const handleLogout = async () => {
    try {
      await fetch("/api/session", {
        method: "DELETE",
        headers: { "Accept": "application/json" },
        credentials: "include",
      });
    } catch (error) {
      console.error("❌ خطا در خروج:", error);
    } finally {
      localStorage.removeItem("loggedIn");
      localStorage.removeItem("userId");
      navigate("/login");
    }
  };

  return (
    <>
      <button className="menu-toggle-btn" onClick={toggleDrawer}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {isOpen && <div className="drawer-overlay" onClick={toggleDrawer} />}

      <div className={`drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <FaMapMarkedAlt className="drawer-logo" />
          <span className="drawer-title">ردیاب هوشمند</span>
        </div>

        <ul>
          <li onClick={() => handleNavigation("/map")}>
            <span className="menu-icon map-icon"><FaMapMarkedAlt /></span>
            نقشه
          </li>
          <li onClick={() => handleNavigation("/reports")}>
            <span className="menu-icon report-icon"><FaChartLine /></span>
            گزارش‌ها
          </li>
          <li onClick={() => handleNavigation("/services")}>
            <span className="menu-icon service-icon"><FaTools /></span>
            سرویس دوره‌ای
          </li>
          <li className="logout-item" onClick={handleLogout}>
            <span className="menu-icon logout-icon"><FaSignOutAlt /></span>
            خروج
          </li>
        </ul>
      </div>
    </>
  );
};

export default Drawer;
